export default __webpack_public_path__ + "static/hero-browser-9a3a162500460e26a0d57fbd28100b02.png";